import login from './login.json';
import zid from './zid.json';
import signup from './signup.json';
import settings from './settings.json';
import salla from './salla.json';
import integrations from './integrations.json';
import integrationApps from './integrationApps.json';
import inboxMgmt from './inboxMgmt.json';
import generalSettings from './generalSettings.json';
import auditLogs from './auditLogs.json';

export default {
  ...login,
  ...zid,
  ...signup,
  ...settings,
  ...salla,
  ...integrations,
  ...integrationApps,
  ...inboxMgmt,
  ...generalSettings,
  ...auditLogs,
};
